// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.renterrole.RentalManagerRenterRoleWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  RentalManagerRenterRoleDeleteRequestDto,
  RentalManagerRenterRoleUpdateRequestDto,
  RentalManagerRenterRoleUpdateResponseWebDto,
} from '../..';

export const RentalManagerRenterRoleWebApiHandler_delete_Path = '/api/web/v1/users/renterRole/delete';

/**
 * Delete existing renters' roles
 */
export const RentalManagerRenterRoleWebApiHandler_delete = (
  postData: RentalManagerRenterRoleDeleteRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RentalManagerRenterRoleDeleteRequestDto, void>(
    {
      endpoint: RentalManagerRenterRoleWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerRenterRoleWebApiHandler_update_Path = '/api/web/v1/users/renterRole/update';

/**
 * Update existing renter's roles
 */
export const RentalManagerRenterRoleWebApiHandler_update = (
  postData: RentalManagerRenterRoleUpdateRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    RentalManagerRenterRoleUpdateRequestDto,
    RentalManagerRenterRoleUpdateResponseWebDto
  >(
    {
      endpoint: RentalManagerRenterRoleWebApiHandler_update_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
